import { Address, AddressCardModel } from '@/models';

const address = new Address('123 Test Ave', 'Unit 9001', 'Test', 'TX', '12345');
const model = new AddressCardModel('Test Site 1', '1234', address);

export const data = {
  address: address,
  model: model
}
